import React from 'react'
import { Badge } from 'react-bootstrap'
/* eslint-disable no-unused-vars */
import Formatter from '../../../helper/formatter'
import DateTime from '../../../helper/datetime'
import translate from '../../../helper/translate'
import { columnResource } from '../../../helper/translatePage/languageResource'
// eslint-disable-next-line import/no-unresolved
import dataType from '../../../helper/constant/dataType'

const ProdukColumn = (actionFun, languange) => ({
  key: 'username',
  columns: [
    {
      name: 'Username',
      selector: 'username',
      sortable: true,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Nama Produk',
      selector: 'nama_produk',
      sortable: false,
      type: dataType.STRING,
      showFilter: true,
    },
    {
      name: 'Kategori',
      selector: 'jenis_trx',
      sortable: true,
      cell: (row) => {
        let word
        let color
        switch (`${row.jenis_trx}`) {
          case 'CASH OUT':
            word = 'CASH OUT'
            color = 'warning'
            break
          case 'CASH IN':
            word = 'CASH IN'
            color = 'primary'
            break
          default:
            word = ''
            color = 'secondary'
            break
        }
        return <Badge variant={color}>{word}</Badge>
      },
      type: dataType.ENUM,
      default_value: [
        {
          id: 'CASH OUT',
          name: 'CASH OUT',
        },
        {
          id: 'CASH IN',
          name: 'CASH IN',
        },
      ],
      showFilter: true,
    },
    {
      name: 'Harga',
      selector: (row) => {
        if (row.is_prosen) {
          if (row.fee_admin_prosen !== '0' && row.fee_admin_prosen !== '0.00') {
            return `${row.fee_admin_prosen}%`
          }
          return row.nominal_admin
        }
        if (row.fee_admin !== undefined && row.fee_admin !== null && row.fee_admin !== 0) {
          return row.fee_admin
        }
        return row.nominal_admin
      },
      sortable: false,
      type: dataType.STRING,
      showFilter: false,
    },
    {
      name: 'Gangguan',
      selector: 'is_gangguan',
      sortable: true,
      cell: (row) => {
        let word
        let color
        if (row.is_gangguan) {
          word = 'Ya'
          color = 'success'
        } else {
          word = 'Tidak'
          color = 'danger'
        }
        return <Badge variant={color}>{word}</Badge>
      },
      type: dataType.ENUM,
      showFilter: true,
      default_value: [
        {
          id: false,
          name: 'Tidak',
        },
        {
          id: true,
          name: 'Ya',
        },
      ],
    },
  ],
})

export default ProdukColumn
